"use strict";

import { Application } from "../../main/application.js";

export class AssetImporter {
    static _assetLoader = undefined;

    static _fontDatabase;
    static get fontDatabase() {
        return AssetImporter._fontDatabase;
    }

    static _assetCount;
    static get assetCount() {
        return AssetImporter._assetCount;
    }

    static initialize(loader) {
        AssetImporter._assetLoader = loader;
        AssetImporter._fontDatabase = [];
        AssetImporter._assetCount = 0;
    }

    static addFont(family) {
        AssetImporter._fontDatabase.push(new FontFaceObserver(family, { weight: 100 }).load());
    }
    
    static addAsset(id,path) {
        AssetImporter._assetLoader.add(id, path);
        AssetImporter._assetCount++;
    }

    static resourcesFind(id) {
        return Application.main.loader.resources[id];
    }
    static sheetFind(sheet,id) {
        return Application.main.loader.resources[sheet].textures[id];
    }
}